<div class="container-fluid">
  <div class="card">

    <!-- Header -->
    <div class="card-header nocollapse">
      Manage Service Provider
    </div>

    <!-- Action buttons (same pattern as user) -->
    <div class="page-attributes p-1" style="margin-left:10px; margin-top:0;">
      <button class="btn btn-sm btn-primary btn-action"
              (click)="openCreateCompanyModal()">
        <i class="fa fa-plus"></i> Create New Provider
      </button>

      <button class="btn btn-sm btn-primary btn-action"
              (click)="getMasterCompanyList()">
        <i class="fa fa-file-excel-o"></i> Export Master Provider List
      </button>
    </div>

    <!-- Status message -->
    <div *ngIf="successOrFailureMessage !== ''"
         class="card-header nocollapse bg-info col-md-12 msg-container">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span>{{ successOrFailureMessage }}</span>
    </div>

    <!-- IsgGridComponent (same as user) -->
    <isg-grid [rowData]="companyList"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              [config]="gridConfig"
              (gridReady)="onGridReady($event)">
    </isg-grid>

  </div>
</div>

<!-- ── Create / Edit Company Modal ──────────────────────────── -->
<ng-template #companyModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      {{ currentCompanyId > 0 ? 'Edit' : 'Create' }} Provider Company
    </h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); onClose()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="companyForm">

      <small class="form-text text-danger d-block mb-2"
             *ngIf="companyForm.invalid && companyForm.touched">
        Please enter all required fields.
      </small>
      <small class="form-text text-danger d-block mb-2"
             *ngIf="validImage">
        Image is not in the specified format (max 289×55 px).
      </small>

      <!-- Company Name -->
      <div class="row mb-2">
        <label class="col-md-4 col-form-label">
          Company Name <span class="text-danger">*</span>
        </label>
        <div class="col-md-8">
          <input type="text"
                 maxlength="150"
                 formControlName="companyName"
                 class="form-control form-control-sm"
                 placeholder="Company Name" />
          <small class="text-danger"
                 *ngIf="companyForm.get('companyName')?.hasError('required') && companyForm.get('companyName')?.touched">
            Company Name is required.
          </small>
          <small class="text-danger"
                 *ngIf="companyForm.get('companyName')?.hasError('companyExists')">
            Company already exists.
          </small>
        </div>
      </div>

      <!-- Company Description -->
      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Company Description</label>
        <div class="col-md-8">
          <input type="text"
                 maxlength="200"
                 formControlName="companyDescription"
                 class="form-control form-control-sm"
                 placeholder="Company Description" />
        </div>
      </div>

      <!-- Notify User -->
      <div class="row mb-2">
        <div class="col-md-4"></div>
        <div class="col-md-8 d-flex align-items-center gap-2">
          <input type="checkbox" id="notifyMe" formControlName="notifyMe"
                 class="form-check-input" />
          <label for="notifyMe" class="form-check-label">Notify User</label>
        </div>
      </div>

      <!-- Image Upload -->
      <div class="row mb-2">
        <small class="text-muted mb-1">(Image dimension should be within 289×55)</small>
        <label class="col-md-4 col-form-label">Select Company Image</label>
        <div class="col-md-8">
          <input #fileInput
                 type="file"
                 class="form-control form-control-sm"
                 accept="image/*"
                 (change)="preview(fileInput.files)" />
        </div>
      </div>

      <!-- Image Preview -->
      <div class="row mb-2" *ngIf="imgURL">
        <div class="col-md-8 offset-md-4">
          <img [src]="imgURL" height="55" alt="Company logo preview" />
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss(); onClose()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-primary btn-modal"
            [disabled]="companyForm.invalid || companyForm.get('companyName')?.hasError('companyExists')"
            (click)="modal.close(); saveCompany()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</ng-template>

<!-- ── Delete Confirmation Modal ─────────────────────────────── -->
<ng-template #deleteCompanyModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this Service Provider?</p>
    <p class="text-danger">
      <strong>Note:</strong><br />
      The Service Provider is already mapped to Service Line(s) and deletion will remove
      all those mappings. User responses for this Service Provider will also be deleted.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-danger btn-modal"
            (click)="modal.close(); deleteCompany()">
      <i class="fa fa-trash"></i> Delete
    </button>
  </div>
</ng-template>
